var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsCtCatalonia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_17334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#FCDD09"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 7.5H0.000263214H60ZM0.000263214 17.5H60H0.000263214ZM60 27.5H0.000263214H60ZM0.000263214 37.5H60H0.000263214Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000263214 9.85698H60V5.14294H0.000263214V9.85698ZM60 15.143H0.000263214V19.857H60V15.143ZM0.000263214 29.857H60V25.143H0.000263214V29.857ZM60 35.143H0.000263214V39.857H60V35.143Z",
    fill: "#DA121A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_17334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsCtCatalonia);
export default __webpack_public_path__ + "static/media/es-ct Catalonia.5cb464e365a0ff9be70392da7d30a359.svg";
export { ForwardRef as ReactComponent };